module.exports = __webpack_public_path__ + "img/message-text.d41ce580.svg";